import React from "react";
import useModal from "../../hooks/useModal";
import { SearchIcon } from "../../../assets/icons";
import "./InputSearch.css";

const InputSearch = ({
  searchData = () => {},
  renderData = () => {},
  classNameContent = "",
  classNameInputSearch = "",
  placeholder = "",
  isDrowMenu=true,
  isLoading,
}) => {
  const [ref, isComponentVisible, setIsComponentVisible] = useModal(false);

  return (
    <div
      className={`content-default ${classNameContent}`}
      style={{ position: "relative" }}
      ref={ref}
    >
      <div
        onClick={() => isDrowMenu && setIsComponentVisible(true)}
        className={"input-search-bar"+classNameInputSearch}
      >
        <input
          className="input-search-input-inside"
          type="text"
          placeholder={placeholder}
          onChange={(e) => searchData(e.target.value)}
          onFocus={(e) => searchData(e.target.value)}
        />
        <SearchIcon className="icon-search-bar" />
      </div>
      {isComponentVisible && (
        <div
          style={{ overflow: "auto" }}
          className="scroll-menu input-search-content-result"
        >
          {!isLoading ? renderData : "cargando"}
        </div>
      )}
    </div>
  );
};

export default InputSearch;
